"use client";
import { useId } from "react";
import PropTypes from "prop-types";

import iconSet from "./icon-set";

import styles from "./styles.module.css";

const NearByListingsCard = ({ data, onClick }) => {
  const id = useId();
  const { categoryName, poies, categoryKey, categoryId } = data || {};

  const notAvailableMessages = {
    TRANSPORTATION: "2 km yakınında ulaşım noktası bulunmamaktadır.",
    SCHOOL: "2 km yakınında eğitim kurumu bulunmamaktadır.",
    MARKET: "2 km yakınında market bulunmamaktadır.",
    CAFE_RESTAURANT: "2 km yakınında restoran bulunmamaktadır.",
    HEALTH: "2 km yakınında sağlık kurumu bulunmamaktadır.",
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.topWrap}>
        <span className={styles.iconWrap}>{iconSet.find((x) => x.id === data.categoryId).icon}</span>
        <h3 className={styles.title}>{categoryName}</h3>
      </div>
      <ul className={styles.list}>
        {poies.length ? (
          poies.map((item, index) => (
            <li key={`${id}-${index}`} onClick={() => onClick({ item, categoryId })} className={styles.poi}>
              <span className={styles.name} title={item?.name}>
                {item?.name}
              </span>
              <span className={styles.meter} title={item?.distance}>
                {item?.distance}
              </span>
            </li>
          ))
        ) : (
          <span className={styles.notAvailablePoi}>{notAvailableMessages[categoryKey]}</span>
        )}
      </ul>
    </div>
  );
};

NearByListingsCard.propTypes = {
  onClick: PropTypes.func,
  data: PropTypes.object,
};

export default NearByListingsCard;
